module.exports = __webpack_public_path__ + "static/media/ic-sort-za-fill.3c3ef524.svg";